import { config } from '../../../config/config';
import { getVersion } from '../helpers/get-functions';

export const sendLogData = async (
  section: string,
  trigger: 'Registration Failed' | 'Loqate Error' | 'Page is loading' | 'Login Failed',
  fields: { [key: string]: string | number | null | unknown },
  errorMessage: string | unknown,
  additionalInfo?: string,
) => {
  const { isProd } = getVersion();
  if (!isProd) return;

  const requestData = {
    jsonrpc: '2.0',
    method: 'log',
    params: {
      section: section,
      trigger: trigger,
      data: {
        fields: {
          ...fields,
          location: document.location.href,
        },
        additionalInfo: additionalInfo,
      },
      errorMessage: errorMessage,
    },
    id: 1,
  };

  try {
    const response = await fetch(config.REQUESTS.LOG, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': config.HEADERS.AUTHORIZATION,
        'Referer': 'powerplay.com',
      },
      body: JSON.stringify(requestData),
    });
    return await response.json();
  } catch (error) {
    console.log('Error:', error);
  }
};
